import React from "react";
import { GetAllCardsResponse } from "@payment-client/interfaces/CardApi";

export interface PaymentModesContextValue {
    loadingPaymentModes: boolean;
    getAllCardsResponse?: GetAllCardsResponse | null;
    reloadPaymentModes: () => void;
}

export const PaymentModesContext = React.createContext<PaymentModesContextValue>({
    loadingPaymentModes: true,
    reloadPaymentModes: () => void 0,
});

if (__DEV__) {
    PaymentModesContext.displayName = "PaymentModesContext";
}
